export default __webpack_public_path__ + "static/media/hero-doctor-desktop.f4ff3450.jpg";